module.exports = __webpack_public_path__ + "img/allottee1_7-8-2021.a333c368.jpg";